(() => {
  if (window.__andCardRealImage) return;
  window.__andCardRealImage = true;
  document.addEventListener('pointerover', event => {
    if(event.pointerType !== 'mouse') return;
    const media = event.target.closest('.sky-product-item-image');
    if(media && media.querySelector('.product-scene-image')) media.classList.add('and-show-real-image');
  });
  document.addEventListener('pointerout', event => {
    if(event.pointerType !== 'mouse') return;
    const media = event.target.closest('.sky-product-item-image');
    if(media && (!event.relatedTarget || !media.contains(event.relatedTarget))) media.classList.remove('and-show-real-image');
  });
  let active;
  let timer;
  let startX = 0, startY = 0;
  const clear = () => {
    if (active) active.classList.remove('and-show-real-image');
    active = null;
  };
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    const media = event.target.closest('.sky-product-item-image');
    if (!media || !media.querySelector('.product-scene-image')) return;
    startX = event.clientX; startY = event.clientY;
    clearTimeout(timer);
    clear();
    active = media;
    active.classList.add('and-show-real-image');
  }, { passive: true, capture: true });
  document.addEventListener('pointermove', event => {
    if (active && (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8)) {
      clearTimeout(timer); clear();
    }
  }, {passive:true,capture:true});
  for (const eventName of ['pointerup', 'pointercancel']) {
    document.addEventListener(eventName, () => {
      if (active) timer = setTimeout(clear, 900);
    }, { passive: true, capture: true });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { clearTimeout(timer); clear(); }
  });
})();

// Reinitialize only missing instances after Shopify replaces a section.
(() => {
  const init = root => {
    if(typeof Swiper !== 'function') return;
    root.querySelectorAll('.spi-product-list .swiper, .sky-image-list .swiper, .sky-video_item .swiper').forEach(el => {
      if(el.swiper && !el.swiper.destroyed) { el.swiper.update(); return; }
      if(el.closest('.sky-video_item')) {
        const section=el.closest('.shopify-section') || el.parentElement;
        new Swiper(el,{speed:600,slidesPerView:1.2,spaceBetween:20,observer:true,observeParents:true,navigation:{nextEl:section.querySelector('.swiper-button-next'),prevEl:section.querySelector('.swiper-button-prev')},scrollbar:{el:section.querySelector('.swiper-scrollbar'),draggable:true},breakpoints:{769:{slidesPerView:2.5},1025:{slidesPerView:3.15},1280:{slidesPerView:4.4}}});
        return;
      }
      const imageList = !!el.closest('.sky-image-list');
      const breakpoints = imageList ? {
        320:{slidesPerView:1.2,slidesPerGroup:1},480:{slidesPerView:2,slidesPerGroup:1},768:{slidesPerView:2.15,slidesPerGroup:2},1024:{slidesPerView:2.5,slidesPerGroup:2},1441:{slidesPerView:4.15,slidesPerGroup:2}
      } : {320:{slidesPerView:1.15,slidesPerGroup:1},768:{slidesPerView:2.15,slidesPerGroup:2},1280:{slidesPerView:3.15,slidesPerGroup:2}};
      new Swiper(el,{slidesPerView:1,slidesPerGroup:1,spaceBetween:20,speed:600,touchRatio:.75,observer:true,observeParents:true,pagination:{el:el.querySelector('.pagination-products'),clickable:true},breakpoints});
    });
  };
  const ready = () => setTimeout(() => init(document),0);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ready); else ready();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:select',event => init(event.target));
})();

// Touch fallback: advance only when Swiper did not already finish the swipe.
(() => {
  let gesture=null, blockClickUntil=0;
  document.addEventListener('touchstart',event=>{
    if(event.touches.length!==1)return;
    const el=event.target.closest('.spi-product-list .swiper, .sky-image-list .swiper, .sky-video_item .swiper');
    if(!el || !el.swiper)return;
    const t=event.touches[0];gesture={el,x:t.clientX,y:t.clientY,index:el.swiper.activeIndex};
  },{passive:true,capture:true});
  document.addEventListener('touchend',event=>{
    if(!gesture)return;const g=gesture;gesture=null;const t=event.changedTouches[0];if(!t)return;
    const dx=t.clientX-g.x,dy=t.clientY-g.y;
    if(Math.abs(dx)<35 || Math.abs(dx)<Math.abs(dy)*1.25)return;
    blockClickUntil=Date.now()+500;
    setTimeout(()=>{const sw=g.el.swiper;if(sw && !sw.destroyed && sw.activeIndex===g.index){dx<0?sw.slideNext():sw.slidePrev();}},0);
  },{passive:true,capture:true});
  document.addEventListener('touchcancel',()=>{gesture=null},{passive:true,capture:true});
  document.addEventListener('click',event=>{if(Date.now()<blockClickUntil && event.target.closest('.spi-product-list .swiper, .sky-image-list .swiper, .sky-video_item .swiper')){event.preventDefault();event.stopPropagation();}},true);
})();

/* Persistent mobile Real Image: click navigation and swipe handling stay untouched. */
(() => {
  let preview;
  const watched=new WeakSet();
  const clear=()=>{if(preview){preview.classList.remove('and-mobile-real-preview');preview.classList.remove('and-show-real-image');}preview=null;};
  const watch=media=>{
    const el=media.closest('.swiper'),sw=el && el.swiper;
    if(sw && !watched.has(sw)){watched.add(sw);sw.on('slideChange',clear);}
  };
  const showAt=(target,x,y)=>{
    if(!target || !target.closest)return;
    if(target.closest('.sky-colors-swatch-i, .sky-color-swatch')){clear();return;}
    const card=target.closest('.sky-product-info');if(!card)return;
    const media=card.querySelector('.sky-product-item-image');if(!media)return;
    const b=media.getBoundingClientRect();
    if(x<b.left || x>b.right || y<b.top || y>b.bottom)return;
    if(preview!==media)clear();
    if(!media.querySelector('.product-scene-image img'))return;
    preview=media;watch(media);media.classList.add('and-mobile-real-preview');
  };
  document.addEventListener('touchstart',event=>{
    if(event.touches.length!==1)return;const t=event.touches[0];showAt(event.target,t.clientX,t.clientY);
  },{passive:true,capture:true});
  document.addEventListener('touchmove',event=>{
    if(event.touches.length!==1)return;const t=event.touches[0];
    const target=document.elementFromPoint(t.clientX,t.clientY);
    // Reaching another card clears the old preview; a settled finger can preview its image.
    if(preview && target && target.closest('.sky-product-info')!==preview.closest('.sky-product-info'))clear();
    showAt(target,t.clientX,t.clientY);
  },{passive:true,capture:true});
  document.addEventListener('click',event=>{
    if(event.target.closest('.sky-colors-swatch-i, .sky-color-swatch'))clear();
  },{capture:true});
})();
